import { usePublisher } from '@magalu/mixer-publisher';
var useShareLinksEvents = function useShareLinksEvents(_ref) {
  var structure = _ref.structure,
    isDesktop = _ref.isDesktop;
  var _usePublisher = usePublisher(),
    publish = _usePublisher.publish;
  var productName = isDesktop ? structure == null ? void 0 : structure.route.slug : structure == null ? void 0 : structure.route.productSlug;
  var productId = structure == null ? void 0 : structure.route.productId;
  var handleCopyLinkEvent = function handleCopyLinkEvent(_ref2) {
    var shareAction = _ref2.shareAction,
      linkType = _ref2.linkType;
    return publish('pmd:sharelinks:share:product:click', {
      linkType: linkType,
      pageType: structure == null ? void 0 : structure.name,
      productId: productId,
      productName: productName,
      shareAction: shareAction
    });
  };
  var handleAddToReadyBagEvent = function handleAddToReadyBagEvent() {
    return publish('pmd:sharelinks:add:ready:bag:click', {
      productId: productId,
      productName: productName
    });
  };
  return {
    handleAddToReadyBagEvent: handleAddToReadyBagEvent,
    handleCopyLinkEvent: handleCopyLinkEvent
  };
};
export default useShareLinksEvents;